// extracted by mini-css-extract-plugin
export var locationCard = "_i2-0";